export * from './lib/aimc-data-access.module';
export { AimcService } from './lib/aimc.service';
